import React from 'react';
import GenericLoaderSVG from '../../images/generic-loader.svg';
import './LoadingMessage.scss';

const LoadingMessage = () => <div className="loader__container"><GenericLoaderSVG /></div>;

export default LoadingMessage;
